import { BaseEntity } from "./base-entity";

export interface Street extends BaseEntity {
  name: string;
  type: string;
  postalCode: string;
}

export namespace Street {

  export function equals(street1: Street, street2: Street): boolean {
    return street1 && street2
      ? street1.name === street2.name
      : street1 === street2;
  }

  export function showName(street: Street | string): string {
    if (street == null) {
      return null;
    }
    if (typeof street === 'string') {
      return street;
    }
    return street.name;
  }

  export function of(name: string): Street {
    return {
      name: name,
      type: 'Strada',
      postalCode: null,
      uuid: null,
      createdTime: undefined
    };
  }
}
